import { Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { useFormatNumber } from '../../../../../hooks/useFormatNumber';

export interface MyTableCurrencyBanks {
  balance: number,
  balancePay: number,
  balanceFree: number,
  currency_id: number,
  currency_code: string
}

export const useCurrencyBankAccounts = () => {
  const [t] = useTranslation("global");
  const { setFormatNumberFromTable } = useFormatNumber();

  const numberWithNotFormat = (value: string): number => {
    return parseFloat(value.replace(/[$,]/g, ''));
  }

  const columnsCurrencyBankAccounts: GridColDef<MyTableCurrencyBanks>[] = [
    {
      field: 'currency_code', headerName: t("currencies.title-view"), headerClassName: 'header-grid-table', flex: 1,
      renderCell(params) {
        return <>
          <Typography>
            {params.value}
          </Typography>
        </>
      }
    },
    {
      field: 'balance', headerName: t("payments.balance-table.balance"), headerClassName: 'header-grid-table', flex: 1,
      renderCell(params) {
        let value = params.value;
        if (typeof value === 'string')
          value = numberWithNotFormat(value);
        return <>
          <Typography sx={{ color: typeof value === 'number' && value < 0 ? 'red' : 'inherit', }}>
            {setFormatNumberFromTable(params.value ?? 0)}
          </Typography>
        </>
      },
    },
    {
      field: 'balancePay', headerName: t("payments.balance-table.pay_balance"), headerClassName: 'header-grid-table', flex: 1,
      renderCell(params) {
        let value = params.value;
        if (typeof value === 'string')
          value = numberWithNotFormat(value);
        return <>
          <Typography sx={{ color: typeof value === 'number' && value < 0 ? 'red' : 'inherit', }}>
            {setFormatNumberFromTable(params.value ?? 0)}
          </Typography>
        </>
      },
    },
    {
      field: 'balanceFree', headerName: t("payments.balance-table.free_balance"), headerClassName: 'header-grid-table', flex: 1,
      renderCell(params) {
        let value = params.value;
        if (typeof value === 'string')
          value = numberWithNotFormat(value);
        return <>
          <Typography sx={{ color: typeof value === 'number' && value < 0 ? 'red' : 'inherit', }}>
            {setFormatNumberFromTable(params.value ?? 0)}
          </Typography>
        </>
      },
    },
  ]

  return {
    columnsCurrencyBankAccounts,
  }
}
